/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import * as v from "valibot"

/**
 * Builds a string schema that rejects empty and whitespace-only values.
 *
 * @param message - The error message for a blank value.
 * @returns A Valibot schema for use in `v.object`.
 *
 * @remarks
 * The check uses `trim()` only for validation; the original value is returned
 * unchanged, so leading and trailing spaces remain part of the input. This
 * matches the API's `@NotBlank` semantics.
 *
 * @example
 * v.object({ username: nonBlankString("Enter your username") })
 * v.is(nonBlankString("Enter your username"), "   ") // false
 */
export const nonBlankString = (message: string) =>
    v.pipe(
        v.string(),
        v.check((value) => value.trim() !== "", message)
    )
